/**
 * PDP Wishlist Popup Handler
 * Handles custom wishlist functionality with variant selection popup
 * Uses Swym API for wishlist operations
 * 
 * Behavior:
 * - If no size is selected: show popup to select variant
 * - If size is selected AND not wishlisted: add directly to wishlist (no popup)
 * - If size is selected AND already wishlisted: show popup for removal
 */
(function() {
  'use strict';

  // Custom Wishlist Button Handler - Button only opens popup
  var wishlistBtn = document.getElementById('pdp-wishlist-btn');
  var wishlistPopup = document.getElementById('wishlist-variant-popup');
  var productWishlistData = []; // Store wishlisted variants for this product

  // Exit early if elements don't exist
  if (!wishlistBtn || !wishlistPopup) return;

  // Get currently selected variant ID from the product form
  function getSelectedVariantId() {
    // Check the product select dropdown first
    var productSelect = document.getElementById('productSelect');
    if (productSelect && productSelect.value) {
      return parseInt(productSelect.value);
    }
    return null;
  }

  // Check if a size swatch is currently selected
  function isSizeSelected() {
    var sizeSwatch = document.querySelector('.swatch[data-swatch="size"]');
    if (!sizeSwatch) return true; // If no size swatch exists, consider it "selected"
    
    var checkedInput = sizeSwatch.querySelector('input[type="radio"]:checked');
    return checkedInput !== null;
  }

  // Check if a specific variant is already in wishlist
  function isVariantWishlisted(variantId) {
    return productWishlistData.some(function(item) {
      return item.epi === variantId;
    });
  }

  // Update main wishlist button to show active state based on selected variant
  function updateMainButtonState() {
    if (!wishlistBtn) return;
    
    var selectedVariantId = getSelectedVariantId();
    
    // If a variant is selected, show heart state based on that variant
    // Otherwise, show filled heart if ANY variant is wishlisted
    var isActive = false;
    if (selectedVariantId && isSizeSelected()) {
      isActive = isVariantWishlisted(selectedVariantId);
    } else {
      isActive = productWishlistData.length > 0;
    }
    
    wishlistBtn.classList.toggle('pdp__wishlist-btn--active', isActive);
    wishlistBtn.classList.toggle('swym-added', isActive);

    // a11y (#341): the filled heart is the only cue sighted users get; aria-pressed
    // is the same information for screen reader users.
    wishlistBtn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  }

  // Update variant buttons in popup to show wishlisted state
  function updatePopupVariantStates() {
    if (!wishlistPopup) return;
    
    var variantOptions = wishlistPopup.querySelectorAll('.wishlist-variant-popup__option');
    variantOptions.forEach(function(option) {
      var variantId = parseInt(option.dataset.variantId);
      var isAvailable = option.dataset.variantAvailable === 'true';
      var isWishlisted = productWishlistData.some(function(item) {
        return item.epi === variantId;
      });
      
      option.classList.toggle('wishlisted', isWishlisted);
      
      // Show unavailable variants only if they are wishlisted
      if (!isAvailable) {
        option.style.display = isWishlisted ? 'flex' : 'none';
      }
    });
    
    // Also update main button state
    updateMainButtonState();
  }

  // Fetch and store wishlist data for this product
  function fetchProductWishlistData(swat, callback) {
    if (!wishlistBtn) return;
    var productId = parseInt(wishlistBtn.dataset.productId);
    
    swat.fetch(function(wishlist) {
      productWishlistData = wishlist.filter(function(item) {
        return item.empi === productId;
      });
      if (callback) callback();
    });
  }

  // Add variant to wishlist (can be called with or without variantOption element)
  function addVariantToWishlist(variantId, variantOption, callback) {
    if (!window._swat) {
      console.error('Swym not loaded');
      return;
    }
    
    var productId = parseInt(wishlistBtn.dataset.productId);
    var productUrl = wishlistBtn.dataset.productUrl;
    var productTitle = wishlistBtn.dataset.productTitle;
    var productImage = wishlistBtn.dataset.productImage;
    var productPrice = parseFloat(wishlistBtn.dataset.productPrice) || 0;

    var wishlistItem = {
      epi: parseInt(variantId),
      empi: productId,
      du: productUrl,
      dt: productTitle,
      iu: productImage,
      pr: productPrice
    };

    window._swat.addToWishList(
      wishlistItem,
      function(response) {
        console.log('Added to wishlist:', response);
        // Update local data and UI
        productWishlistData.push(wishlistItem);
        if (variantOption) {
          variantOption.classList.add('wishlisted');
        }
        // Update main button state
        updateMainButtonState();
        if (callback) callback();
      },
      function(error) {
        console.error('Error adding to wishlist:', error);
      }
    );
  }

  // Remove variant from wishlist
  function removeVariantFromWishlist(variantId, variantOption) {
    if (!window._swat) return;
    
    var item = productWishlistData.find(function(i) {
      return i.epi === parseInt(variantId);
    });
    
    if (item) {
      window._swat.removeFromWishList(
        { empi: item.empi, epi: item.epi },
        function() {
          console.log('Removed from wishlist');
          // Update local data and UI
          productWishlistData = productWishlistData.filter(function(i) {
            return i.epi !== parseInt(variantId);
          });
          variantOption.classList.remove('wishlisted');
          // Update main button state
          updateMainButtonState();
        }
      );
    }
  }

  // Show popup and refresh wishlist states
  function showWishlistPopup() {
    if (wishlistPopup) {
      // Refresh wishlist data before showing
      if (window._swat) {
        fetchProductWishlistData(window._swat, function() {
          updatePopupVariantStates();
        });
      }
      wishlistPopup.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      // Accessibility: set ARIA attributes and move focus into the popup
      wishlistPopup.setAttribute('role', 'dialog');
      wishlistPopup.setAttribute('aria-modal', 'true');
      wishlistPopup.setAttribute('aria-label', 'Add to Wishlist');
      var popupContent = wishlistPopup.querySelector('.wishlist-variant-popup__content');
      if (popupContent && !popupContent.hasAttribute('tabindex')) {
        popupContent.setAttribute('tabindex', '-1');
      }
      // Focus the close button or content after a short delay for display transition
      setTimeout(function() {
        var closeEl = wishlistPopup.querySelector('.wishlist-variant-popup__close');
        if (closeEl) {
          closeEl.focus();
        } else if (popupContent) {
          popupContent.focus();
        }
      }, 50);

      // Accessibility: trap focus and handle Escape
      wishlistPopup._keyHandler = function(e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeWishlistPopup();
          return;
        }
        if (e.key === 'Tab') {
          var focusable = wishlistPopup.querySelectorAll(
            'button:not([disabled]):not([style*="display: none"]), [tabindex]:not([tabindex="-1"])'
          );
          if (!focusable.length) return;
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (e.shiftKey) {
            if (document.activeElement === first) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
          }
        }
      };
      document.addEventListener('keydown', wishlistPopup._keyHandler);
    }
  }

  // Close popup
  function closeWishlistPopup() {
    if (wishlistPopup) {
      wishlistPopup.style.display = 'none';
      document.body.style.overflow = '';

      // Remove keyboard handler
      if (wishlistPopup._keyHandler) {
        document.removeEventListener('keydown', wishlistPopup._keyHandler);
        wishlistPopup._keyHandler = null;
      }

      // Return focus to the wishlist button
      if (wishlistBtn) {
        wishlistBtn.focus();
      }
    }
  }

  // Wishlist button click handler - Smart behavior based on variant selection
  wishlistBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    var selectedVariantId = getSelectedVariantId();
    var sizeSelected = isSizeSelected();
    
    // If no size is selected, always show popup to select variant
    if (!sizeSelected || !selectedVariantId) {
      showWishlistPopup();
      return;
    }
    
    // Size is selected - check if variant is already wishlisted
    var isWishlisted = isVariantWishlisted(selectedVariantId);
    
    if (isWishlisted) {
      // Variant is already wishlisted - show popup for removal
      showWishlistPopup();
    } else {
      // Variant is NOT wishlisted - add directly without popup
      addVariantToWishlist(selectedVariantId, null, function() {
        // Optional: Show a brief feedback (e.g., animate the heart)
        console.log('Variant added to wishlist directly');
      });
    }
  });

  // Popup close handlers
  var closeBtn = wishlistPopup.querySelector('.wishlist-variant-popup__close');
  var overlay = wishlistPopup.querySelector('.wishlist-variant-popup__overlay');
  
  if (closeBtn) {
    closeBtn.addEventListener('click', closeWishlistPopup);
  }
  if (overlay) {
    overlay.addEventListener('click', closeWishlistPopup);
  }

  // Variant option click handler - toggle add/remove
  var variantOptions = wishlistPopup.querySelectorAll('.wishlist-variant-popup__option');
  variantOptions.forEach(function(option) {
    option.addEventListener('click', function() {
      var variantId = this.dataset.variantId;
      var isWishlisted = this.classList.contains('wishlisted');
      
      if (isWishlisted) {
        removeVariantFromWishlist(variantId, this);
      } else {
        addVariantToWishlist(variantId, this);
      }
    });
  });

  // Initialize when Swym is ready
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(function(swat) {
    fetchProductWishlistData(swat, updatePopupVariantStates);
  });

  // Listen for variant changes to update button state
  var productSelect = document.getElementById('productSelect');
  if (productSelect) {
    productSelect.addEventListener('change', function() {
      updateMainButtonState();
    });
  }
  
  // Also listen for swatch clicks to update button state
  var sizeSwatch = document.querySelector('.swatch[data-swatch="size"]');
  if (sizeSwatch) {
    sizeSwatch.addEventListener('change', function() {
      // Small delay to ensure variant select is updatedd
      setTimeout(updateMainButtonState, 100);
    });
  }
  
  // Listen for custom variant change event (dispatched by the theme)
  window.addEventListener('tn-variant-changed', function() {
    setTimeout(updateMainButtonState, 100);
  });

  // Hide Swym's default button since we have our own, and remove gap from wrapper
  var style = document.createElement('style');
  style.textContent = '#swym-atw-pdp-button { display: none !important; } .swym-atw-btn-wrapper.add_to_cart_button_right-position { gap: 0 !important; }';
  document.head.appendChild(style);

})();
